export const colors = {
  Light_Gray_Prom: '#F6F6F6',
  Gray_1: '#333333',
  Green_Prom: '#54B58F',
  Green_2_Prom: '#4FAA9F',
};
